import Image from 'next/image';
import React, { ReactElement, useEffect, useState } from 'react';

import { getDownloadPCFeatureFlag, waitForAmplitudeExperimentInitialized } from '../../../../../utils/analytics';
import { DOWNLOAD_APPLE_CHIP_MAC_URL,DOWNLOAD_INTEL_CHIP_MAC_URL, DOWNLOAD_WINDOWS_URL } from '../../constants';
import * as S from './Hero.styles';

export const Hero = (): ReactElement => {

  const [showWindowDownloadButton, setShowWindowDownloadButton] = useState(false);

  useEffect(() => {
    async function getShowWindowDownloadButton() {
      await waitForAmplitudeExperimentInitialized(5000);
      const isDownloadPCFeatureFlag = getDownloadPCFeatureFlag();
      setShowWindowDownloadButton(isDownloadPCFeatureFlag === 'on');
    }
    
    getShowWindowDownloadButton();
  }, []);

  return (
    <S.Wrapper>
      <S.ContentContainer>
        <S.LeftTitleContainer>
          <p>
            Brain.fm for<br />
            Desktop
          </p>
        </S.LeftTitleContainer>

        <S.LeftDescriptionContainer>
          Boost your productivity right from your desktop.
        </S.LeftDescriptionContainer>

        <S.MobileBackground>
          <S.MobileImage
            alt={'brain.fm mobile'}
            loading="lazy"
            src={'https://cdn.brain.fm/images/download_hero_3_mobile.webp'}
            style={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        </S.MobileBackground>

        <S.LeftButtonContainer>
          <S.ButtonContainer>
            <S.Button href={DOWNLOAD_INTEL_CHIP_MAC_URL}>
              <S.ButtonIcon src={'https://cdn.brain.fm/icons/apple-black.svg'} />
              MAC WITH INTEL CHIP
            </S.Button>
            <S.ButtonNote>Mac OS X 10.5+</S.ButtonNote>
          </S.ButtonContainer>

          <S.ButtonContainer>
            <S.Button href={DOWNLOAD_APPLE_CHIP_MAC_URL}>
              <S.ButtonIcon src={'https://cdn.brain.fm/icons/apple-black.svg'} />
              MAC WITH APPLE CHIP
            </S.Button>
            <S.ButtonNote>Mac OS 11+</S.ButtonNote>
          </S.ButtonContainer>

          {showWindowDownloadButton ? (
            <S.ButtonContainer>
              <S.Button href={DOWNLOAD_WINDOWS_URL}>
                <S.ButtonIcon src={'https://cdn.brain.fm/icons/windows-black.svg'} />
                WINDOWS
              </S.Button>
              <S.ButtonNote>Windows</S.ButtonNote>
            </S.ButtonContainer>
          ) : null}
        </S.LeftButtonContainer>

        <S.LeftQuestionContainer>
          Not sure? <a href="https://support.apple.com/en-us/116943"> Find your chip.</a>
        </S.LeftQuestionContainer>
      </S.ContentContainer>

      <S.BackgroundBlur>
        <Image
          alt={'brain.fm background gradient'}
          layout="fill"
          loading="lazy"
          src={'https://cdn.brain.fm/images/download_hero_circle_blur.webp'}
        />
      </S.BackgroundBlur>
      <S.Background>
        <img
          alt={'brain.fm menu bar app'}
          src={'https://cdn.brain.fm/images/download_hero_desktop.webp'}
          style={{ maxWidth: '1210px' }}
        />
      </S.Background>
    </S.Wrapper>
  );
};
